import { render, staticRenderFns } from "./DIYBreadcrumb.vue?vue&type=template&id=1e85400e&lang=pug"
import script from "./DIYBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./DIYBreadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./DIYBreadcrumb.vue?vue&type=style&index=0&id=1e85400e&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default,Icon: require('/app/components/vantone/Icon.vue').default})
